import { render, staticRenderFns } from "./EditReleaseButton.vue?vue&type=template&id=2c9a9b6f"
import script from "./EditReleaseButton.vue?vue&type=script&lang=js"
export * from "./EditReleaseButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports